import { createSelector } from 'reselect'
import { selectUnreadRoomIds } from './realtime'

export const selectIsChangeInboxMenuOpen = state =>
  !!state.menus.changeInboxOpen

export const selectIsMoreTicketOptionsMenuOpen = state =>
  !!state.menus.moreTicketOptionsOpen

export const selectMenuNoticeCounts = createSelector(
  selectUnreadRoomIds,
  unreadRoomIds => ({
    'Live Chat': unreadRoomIds.length,
  })
)
